import _Cmp from '../_app/cuchillo/windows/Cmp';
import { gsap, Power3 } from "gsap";

export default class CMP extends _Cmp {
    static show__effect(__d = 0) {
        // this.container.style.opacity = "1";
        gsap.set(this.container, { y: this.container.offsetHeight, alpha: 1 });
        gsap.to(this.container, { y: 0, duration: .4, ease: Power3.easeOut });
    }

    // static hide__effect(__d = 0) {
    // this.container.style.display = "none";
    // super.hide__effect();
    // console.log('HIDE EFFECT CHILD');
    // gsap.to(this.container, { y: this.container.offsetHeight, duration: .4, ease: Power3.easeOut, onComplete: () => { super.hide__effect(); } });
    // }
}


